import { Outlet, useLocation } from 'react-router-dom'

import { GridStructure } from 'layouts/components'
import { TemporaryPassword } from 'components'
import { Navigation, TemporaryPasswordAlert } from './components'

import { useAuth } from 'hooks'

import { DrawerProvider } from 'providers'
import { useState } from 'react'

const MainLayout = () => {
  const location = useLocation()
  const isTrayRoute = location.pathname.includes('tray')

  const { user, userCompany, showTemporaryPasswordAdvisor } = useAuth()

  const [showTemporaryPassword, setShowTemporaryPassword] = useState(
    user?.temporaryPassword && !userCompany?.company?.hasTrayStore
  )

  const showAdvisor =
    !isTrayRoute && showTemporaryPasswordAdvisor && !showTemporaryPassword

  const handleAlertAction = () => setShowTemporaryPassword(true)

  return (
    <GridStructure>
      <DrawerProvider>
        <Navigation>
          {showAdvisor && (
            <TemporaryPasswordAlert onClick={handleAlertAction} />
          )}
          {showTemporaryPassword ? <TemporaryPassword /> : <Outlet />}
        </Navigation>
      </DrawerProvider>
    </GridStructure>
  )
}

export default MainLayout
